import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons'
import { Switch, Card, Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

import '../../../assets/profile-page.scss'

const DATA_USAGE_TITLE = 'Use of my data'
const DATA_USAGE_TIPS_TEXT = "Manage the sharing of your Interneo's data with other parties."

const OptInForm = ({ optInValue = false, marginBottom, onChange }) => {
  const t = useSelector(selectTranslate)

  const onSwitchChange = () => {
    onChange(!optInValue)
  }

  return (
    <div style={{ marginBottom: marginBottom ?? '5px' }}>
      <Card
        type='inner'
        title={[t(DATA_USAGE_TITLE), ' ',
          <Tooltip key='personal_section_tooltip' placement='right' title={t(DATA_USAGE_TIPS_TEXT)}>
            <FontAwesomeIcon icon={faQuestionCircle} color='#1890ff' />
          </Tooltip>]}
      >
        {[
          <Switch key='recruitement' checked={optInValue} onChange={onSwitchChange} />,
          ' ',
          t('for recruitment purposes')
        ]}
      </Card>
    </div>
  )
}

export default OptInForm
